export default "__VITE_ASSET__741cbaea__"